import { Business, BusinessSSOWithIDPDetails, SSOType } from "lens-platform-sdk";

import { getSSOLoginUrlByBusinessHandle } from "src/services/sso";
import { CopyToClipboard } from "src/components/CopyToClipboard/CopyToClipboard";

import styles from "./BusinessSSO.module.css";

export const BusinessSSOInfo = ({
  ssoInfo,
  business,
}: {
  ssoInfo: BusinessSSOWithIDPDetails;
  business: Business | undefined | null;
}) => {
  const loginUrl = ssoInfo && getSSOLoginUrlByBusinessHandle(business?.handle);

  return (
    <>
      {ssoInfo && ssoInfo.config.type === SSOType.SAML && loginUrl && (
        <div className={styles.ssoInfoSection}>
          <dl className={styles.ssoInfo}>
            <dt aria-label="SSO Login Url">
              <strong>Login URL:</strong>
            </dt>
            <dd aria-label={loginUrl} data-testid="loginUrl">
              <span className={styles.ssoInfoText} title={loginUrl}>
                {loginUrl}
              </span>
              <CopyToClipboard text={loginUrl} />
            </dd>
            <dt aria-label="Single sign-on Service URL">
              <strong>Single sign-on Service URL:</strong>
            </dt>
            <dd aria-label={ssoInfo.config.singleSignOnServiceUrl!}>{ssoInfo.config.singleSignOnServiceUrl}</dd>
            <dt>
              <strong>Identity Provider EntityID:</strong>
            </dt>
            <dd aria-label={ssoInfo.config.idpEntityId!}>{ssoInfo.config.idpEntityId}</dd>
          </dl>
        </div>
      )}
      {ssoInfo && ssoInfo.config.type === SSOType.OIDC && loginUrl && (
        <div className={styles.ssoInfoSection}>
          <dl className={styles.ssoInfo}>
            <dt aria-label="SSO Login Url">
              <strong>Login URL:</strong>
            </dt>
            <dd aria-label={loginUrl} data-testid="loginUrl">
              <span className={styles.ssoInfoText} title={loginUrl}>
                {loginUrl}
              </span>
              <CopyToClipboard text={loginUrl} />
            </dd>
            <dt>
              <strong>Client ID</strong>
            </dt>
            <dd aria-label={ssoInfo.config.clientId!}>{ssoInfo.config.clientId}</dd>
            <dt aria-label="Authorization URL">
              <strong>Authorization URL</strong>
            </dt>
            <dd aria-label={ssoInfo.config.authorizationUrl!}>{ssoInfo.config.authorizationUrl}</dd>
            <dt>
              <strong>Token URL</strong>
            </dt>
            <dd aria-label={ssoInfo.config.tokenUrl!}>{ssoInfo.config.tokenUrl}</dd>
            <dt>
              <strong>JWKS URL</strong>
            </dt>
            <dd aria-label={ssoInfo.config.jwksUrl!}>{ssoInfo.config.jwksUrl}</dd>
            <dt>
              <strong>User Info URL</strong>
            </dt>
            <dd aria-label={ssoInfo.config.userInfoUrl!}>{ssoInfo.config.userInfoUrl}</dd>
            {ssoInfo.config.logoutUrl ? (
              <>
                <dt>
                  <strong>Logout URL</strong>
                </dt>
                <dd aria-label={ssoInfo.config.logoutUrl!}>{ssoInfo.config.logoutUrl}</dd>
              </>
            ) : null}
            <dt>
              <strong>Issuer</strong>
            </dt>
            <dd aria-label={ssoInfo.config.issuer!}>{ssoInfo.config.issuer}</dd>
          </dl>
        </div>
      )}
    </>
  );
};
